import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes, IconVariants } from '../foundations/Icon';
import Tooltip from './Tooltip';
import css from './CopyToClipboardButton.css';

const COPY_TIMEOUT = 2000;
const COPIED_TOOLTIP_TEXT = 'STATIC.TOOLTIPS.COPIED';

const CopyToClipboardButton = ({ textToCopy, preCoyIconName = 'copy', tooltip = null, onClick: onClickProp }) => {
    const [copied, setCopied] = useState(false);

    const onClick = e => {
        e.stopPropagation();

        navigator.clipboard.writeText(textToCopy);

        onClickProp && onClickProp();

        setCopied(true);
        setTimeout(() => setCopied(false), COPY_TIMEOUT);
    };

    const clipboardIconDynamicProps = copied
        ? {
              name: 'check',
              variant: IconVariants.SUCCESS,
          }
        : {
              name: preCoyIconName,
              variant: IconVariants.LIGHT,
          };

    const iconElement = <Icon size={IconSizes.MEDIUM} onClick={onClick} {...clipboardIconDynamicProps} />;

    const tooltipTitle = copied ? COPIED_TOOLTIP_TEXT : tooltip;

    // If tooltip props are provided, wrap with Tooltip, otherwise return icon directly
    if (tooltipTitle)
        return (
            <Tooltip titleTranslationKey={tooltipTitle} wrapperClass={css.tooltipWrapper}>
                {iconElement}
            </Tooltip>
        );

    return iconElement;
};

CopyToClipboardButton.propTypes = {
    preCoyIconName: PropTypes.string,
    textToCopy: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
    onClick: PropTypes.func,
};

export default CopyToClipboardButton;
